import { ServerCrash } from 'lucide-react';

import { Button } from '@/components/health-ui';
import { ErrorState } from '@/components/error-state';

type AuthUnavailableProps = {
  /**
   * Recovery action. A Keycloak init failure can only be cleared by a full page
   * reload (keycloak-js instances initialize once), so callers wire this to
   * `window.location.reload()`.
   */
  onRetry: () => void;
};

/**
 * Degraded screen shown when Keycloak initialization fails (e.g. the sign-in
 * service is unreachable). Rendered by the top-level AuthErrorBoundary so an
 * outage degrades cleanly instead of leaving a blank page.
 */
export function AuthUnavailable({
  onRetry,
}: Readonly<AuthUnavailableProps>): React.JSX.Element {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <ErrorState
        tone="danger"
        icon={ServerCrash}
        headline="Sign-in is temporarily unavailable"
        description="We couldn't reach the sign-in service. This is usually temporary — please try again in a moment."
        actions={[
          <Button key="retry" onClick={onRetry}>
            Try again
          </Button>,
        ]}
        compact={false}
      />
    </div>
  );
}
